/**
 * KAN-873: один раз прокрутить элемент в видимую область, когда active стал
 * true (карточка шага, к которому открыт экран "Начало работы").
 */
import { useEffect, useRef, type RefObject } from 'react';

export function useScrollIntoViewOnce(ref: RefObject<Element>, active: boolean): void {
  const done = useRef(false);
  useEffect(() => {
    if (!active || done.current || !ref.current) return;
    done.current = true;
    // jsdom и старые браузеры: метода может не быть.
    ref.current.scrollIntoView?.({ behavior: 'smooth', block: 'start' });
  }, [active, ref]);
}
